import { CategoriaEsame } from '@hm_app/@core/models/esame';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class EsameCategoriaService {
    // Observable sources
    private categoria_esame = new BehaviorSubject<CategoriaEsame>(null);

    // Observable streams
    categoriaEsameObservable = this.categoria_esame.asObservable();

    // Service message commands
    passCategoriaEsame(categoria_esame: CategoriaEsame) {
        this.categoria_esame.next(categoria_esame);
    }
}
